/*
 * @Author: wanghaifeng
 * @Date: 2021-08-19 16:31:28
 * @Description: vuex ppAuth 平台授权
 */

const platformObj = {
  SHOPIFY: {
    LOGO: 'shopify.png',
    PRIVACY_URL: 'https://www.shopify.cn/privacy'
  },
  SHOPLINE: {
    LOGO: 'shopline.png',
    PRIVACY_URL: 'https://shoplineapp.cn/about/privacy/'
  },
}

const state = {
  // 当前授权的平台
  platform: '',
  platformLogo: '',
  platformPrivacyUrl: '',
}

const mutations = {
  getPlatform(state, data) {
    state.platform = data.toUpperCase()
    const platformMap = platformObj[state.platform]
    state.platformLogo = platformMap.LOGO
    state.platformPrivacyUrl = platformMap.PRIVACY_URL
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
